export const UX4_PRIMARY_ORANGE = "#FF5200";
export const UX4_PRIMARY_BLACK = "#686a6d";
